import React from 'react'
import Router from './Router'
import './App.css'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

function App() {
  return (
    <>
      <Router />
      <ToastContainer className={'toast-position'} />
    </>
  );
}

export default App;
